import type { Route } from './constants';

export function parseRoute(pathname: string): { route: Route; previewId?: string } {
  const p = pathname.split('?')[0]?.split('#')[0] || '/';
  if (p === '/privacy') return { route: '/privacy' };
  if (p === '/terms') return { route: '/terms' };
  if (p.startsWith('/preview/')) {
    const id = p.slice('/preview/'.length).trim();
    return { route: '/preview', previewId: id || undefined };
  }
  return { route: '/' };
}
